import invoiceLabels from "emun.invoice/_labels";

export default [
  ...(invoiceLabels.tagFor
    ? [{ groupBy: "TagFor", title: invoiceLabels.tagFor }]
    : []),
  { groupBy: "Status", title: invoiceLabels.status },
  { groupBy: "TransactionType", title: invoiceLabels.transactionType },
  { text: "LineProductId", title: "Product #" },
  { date: "InvoiceDate", title: "Invoice Date" },
  {
    groupBy: "SalesRepName",
    title: "Rep # of Record",
    roles: ["Administrator", "Sales Manager", "Manager", "Web Admin", "Corporate"],
  },
];
